import React, { useCallback, useEffect, useState } from 'react';
import history from 'history/browser';
import Suspense from '../Suspense';
import Cookies from 'js-cookie';
import Events from '../../utils/events';
import { EV_COOKIE_CONSENT_UPDATED } from '../CookieConsent';
import { GlobalChatStyle } from './style';

type TCookieConsent = {
  functionalCookies: boolean;
};

const ChatComponent = React.lazy(() => import('./ChatComponent'));

const validPaths = [
  '/kundservice',
  '/butiker',
  '/handla-pa-mio',
  '/reklamation',
  '/medlem',
  '/presentkort',
  '/tillbehor-och-reservdelar',
];

const checkFunctionalCookieConsent = () => {
  const cookie = Cookies.get('mioCookieConsent');
  if (cookie) {
    const functionalCookie = JSON.parse(cookie) as TCookieConsent;
    return functionalCookie?.functionalCookies;
  }

  return false;
};

export const Chat = () => {
  const [initialized, setInitialized] = useState(false);
  const [consent, setConsent] = useState(false);
  const [show, setShow] = useState(false);

  const validateConsentAndPath = () => {
    const path = history.location.pathname.toLowerCase();

    const valid = validPaths.some((i) => path.includes(i));

    return valid;
  };

  const handleChat = useCallback(() => {
    const validPath = validateConsentAndPath();
    setConsent(checkFunctionalCookieConsent());
    if (validPath) {
      setInitialized(true);
      setShow(true);
    } else {
      setShow(false);
    }
  }, []);

  useEffect(() => {
    history.listen(() => {
      handleChat();
    });

    handleChat();
  }, []);

  Events.on(EV_COOKIE_CONSENT_UPDATED, () => {
    setTimeout(() => {
      handleChat();
    }, 500);
  });

  if (!initialized) {
    return null;
  }

  return (
    <Suspense>
      {/* @ts-ignore - We can resolve this when we update the dependencies/types */}
      <GlobalChatStyle />
      <ChatComponent consent={consent} show={show} />
    </Suspense>
  );
};

export default Chat;
